import React from 'react';
import Logo from '../components/Logo';

export default function LoadingPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#2B4979] via-[#3d5c8f] to-[#2B4979] flex items-center justify-center relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full filter blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#FF7B47] rounded-full filter blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>
      </div>

      <div className="relative z-10 text-center">
        {/* Logo with swoosh effect */}
        <div className="relative inline-block mb-8">
          <div className="transform scale-150 animate-pulsate">
            <Logo />
          </div>
          
          {/* Swoosh overlay effect */}
          <div className="absolute inset-0 overflow-hidden rounded-lg">
            <div className="absolute inset-0 -left-full animate-swoosh bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-12"></div>
          </div>
        </div>

        {/* Loading text */}
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 animate-pulse">
          Nous recherchons les meilleures offres pour vous...
        </h2>

        {/* Loading dots */}
        <div className="flex items-center justify-center gap-2 mt-6">
          <div className="w-3 h-3 bg-[#FF7B47] rounded-full animate-bounce" style={{animationDelay: '0s'}}></div>
          <div className="w-3 h-3 bg-[#FF7B47] rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
          <div className="w-3 h-3 bg-[#FF7B47] rounded-full animate-bounce" style={{animationDelay: '0.4s'}}></div>
        </div>

        {/* Progress bar */}
        <div className="mt-8 w-64 mx-auto">
          <div className="h-2 bg-white/20 rounded-full overflow-hidden">
            <div className="h-full bg-gradient-to-r from-[#FF7B47] to-[#ff6a30] rounded-full animate-progress"></div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes swoosh {
          0% {
            left: -100%;
          }
          100% {
            left: 200%;
          }
        }

        @keyframes progress {
          0% {
            width: 0%;
          }
          50% {
            width: 70%;
          }
          100% {
            width: 100%;
          }
        }

        @keyframes pulsate {
          0%, 100% {
            transform: scale(1.5);
          }
          50% {
            transform: scale(1.7);
          }
        }

        .animate-swoosh {
          animation: swoosh 2s ease-in-out infinite;
        }

        .animate-progress {
          animation: progress 2s ease-in-out infinite;
        }

        .animate-pulsate {
          animation: pulsate 1.5s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}